import { render, staticRenderFns } from "./CouponIndex.vue?vue&type=template&id=3b5b96d7&"
import script from "./CouponIndex.vue?vue&type=script&lang=js&"
export * from "./CouponIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports